import Vue from 'vue'
import VueRouter from 'vue-router'
import OAuthCallbackView from '../views/OAuthCallbackView.vue'
import SignupView from '../views/SignupView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'SignupView',
    component: SignupView,
  },
  {
    path: '/oauth/callback',
    name: 'OAuthCallbackView',
    component: OAuthCallbackView,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router